var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1234_4895)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.9172 12.0771C1.94783 11.8015 1.96314 11.6636 2.00485 11.5348C2.04185 11.4205 2.09413 11.3117 2.16026 11.2114C2.23481 11.0984 2.33287 11.0003 2.52899 10.8042L11.3332 2.00004C12.0696 1.26366 13.2635 1.26366 13.9999 2.00004C14.7362 2.73642 14.7362 3.93033 13.9999 4.66671L5.19565 13.4709C4.99953 13.667 4.90147 13.7651 4.78843 13.8396C4.68814 13.9058 4.57936 13.958 4.46507 13.995C4.33624 14.0367 4.19841 14.0521 3.92275 14.0827L1.6665 14.3334L1.9172 12.0771Z",
    stroke: "#667085",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1234_4895"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit01);
export default __webpack_public_path__ + "static/media/edit-01.59fbd27459ba8a19dcdf76c8f3f9a605.svg";
export { ForwardRef as ReactComponent };